module.exports = __webpack_public_path__ + "img/unknownFormat.3ec47f8c.svg";